/**
 * PPA header nav enhancements (inventory #6, #10) + Olark/cart-drawer overlap
 * fix (inventory #13). Runs once, deferred, from ppa-body-end so the header,
 * header sidebar and cart drawer markup already exist.
 *
 * Everything here is additive DOM enhancement against Prestige 11's own
 * rendered markup (sections/header.liquid, snippets/header-sidebar.liquid,
 * sections/cart-drawer.liquid) — no PPA-HOOK needed for any of it, and no
 * innerHTML: every node this script creates is built with createElement /
 * textContent, and every string it writes is a static constant, never
 * server/variant/search-derived data (see ARCHITECTURE.md Rule 4).
 */
(function () {
  'use strict';

  var NAV_KEYS = ['artists', 'artworks', 'about', 'editorial', 'contact'];
  var ARTISTS_URL = '/pages/artists-a-z';
  var ARTISTS_LABEL = 'All Artists A–Z →';

  function navKey(text) {
    return (text || '').trim().toLowerCase().replace(/\.$/, '');
  }

  function makeAzLink() {
    var a = document.createElement('a');
    a.href = ARTISTS_URL;
    a.className = 'ppa-artists-az-link';
    a.textContent = ARTISTS_LABEL;
    var li = document.createElement('li');
    li.appendChild(a);
    return li;
  }

  var current = (window.ppaNav && window.ppaNav.current) || null;

  /* ---------- Desktop: tag [data-title] nav items, dim the current one ---------- */

  function tagDesktop() {
    var items = document.querySelectorAll('.header [data-title]');
    items.forEach(function (el) {
      var key = navKey(el.getAttribute('data-title') || el.textContent);
      if (NAV_KEYS.indexOf(key) === -1) return;

      el.classList.add('ppa-nav-tag', 'ppa-nav-tag--' + key);
      if (current && key === current) el.classList.add('is-current');

      if (key === 'artists') {
        var details = el.closest('.header__menu-disclosure');
        if (!details) return;
        var list = details.querySelector('.mega-menu__linklist') || details.querySelector('.header__dropdown-menu');
        if (list && !list.querySelector('.ppa-artists-az-link')) {
          list.insertBefore(makeAzLink(), list.firstChild);
        }
      }
    });
  }

  /* ---------- Mobile drawer: same tag treatment + Artists leadoff ----------
     Reviewer correction (medium): `is-current` fades the row to opacity 0
     (desktop-only styling — the tag reads as the same object now hanging as
     the page title), but in the drawer that meant the current-page item went
     blank while still needing to be tappable to open its sub-panel. Live's
     drawer never dims the current item, so only the desktop tagger applies
     `is-current`; the drawer keeps `ppa-nav-tag`/`ppa-nav-tag--<key>` for
     text styling only (see ppa-header-nav.css, scoped to `.header-sidebar`
     so it doesn't also pick up the desktop underline). */

  function tagMobile() {
    var buttons = document.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist-button');
    buttons.forEach(function (el) {
      var key = navKey(el.textContent);
      if (NAV_KEYS.indexOf(key) === -1) return;

      el.setAttribute('data-title', el.textContent.trim());
      el.classList.add('ppa-nav-tag', 'ppa-nav-tag--' + key);
    });

    var backButtons = document.querySelectorAll('.header-sidebar__back-button');
    backButtons.forEach(function (el) {
      if (navKey(el.textContent) !== 'artists') return;
      var panel = el.closest('.header-sidebar__sub-panel');
      var list = panel && panel.querySelector('.header-sidebar__linklist');
      if (list && !list.querySelector('.ppa-artists-az-link')) {
        list.insertBefore(makeAzLink(), list.firstChild);
      }
    });
  }

  try { tagDesktop(); } catch (e) {}
  try { tagMobile(); } catch (e) {}

  /* ---------- Olark vs. cart drawer overlap (inventory #13) ----------
     The launcher sits over the drawer's checkout button. Prestige 11's
     <cart-drawer id="cart-drawer" class="drawer"> host stays in the DOM at
     all times, `position: relative` with no in-flow content — its own
     rendered content lives in a `position: fixed` shadow part, so the host's
     own bounding rect never reflects whether the drawer is actually visible.
     Reviewer correction (high): watch the `open` attribute that
     dialog-like-drawer.show()/hide() set directly (theme.js), not the host's
     computed visibility, which is always zero-size. */

  try {
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && window.MutationObserver) {
      var sync = function () {
        document.body.classList.toggle('ppa-cart-drawer-open', cartDrawer.hasAttribute('open'));
      };
      var observer = new MutationObserver(sync);
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
      sync();
    }
  } catch (e) {}
})();
